import { useState, useEffect } from "react";
import {
  generateTOC,
  getActiveHeadingId,
  TocItem,
} from "../../utils/docs/tocGenerator";

export function useTableOfContents(content: string) {
  const [toc, setToc] = useState<TocItem[]>([]);
  const [activeId, setActiveId] = useState<string | null>(null);

  useEffect(() => {
    const headings = generateTOC(content);
    setToc(headings);
  }, [content]);

  useEffect(() => {
    if (toc.length === 0) return;

    const handleScroll = () => {
      const active = getActiveHeadingId(toc, 100);
      setActiveId(active);
    };

    // Initial check
    handleScroll();

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [toc]);

  return { toc, activeId };
}
